import React from 'react';

export const AlertIcon: React.FC = () => {
    return (
        <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.173 19.024L10.72.712c.546-.95 2.014-.95 2.56 0l10.547 18.312c.516.895-.185 1.976-1.28 1.976H1.454C.357 21-.342 19.919.173 19.024"
                fill="#FFDB4D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5 14h-3V7h3v7zM13.5 17.855h-3v-2.5h3v2.5z"
                fill="#000"
                fillOpacity=".7"
            />
        </svg>
    );
};
